/* Saint Véra, busca nas perguntas das páginas de atendimento (agente K). Idempotente; sem busca no HTML sem JS. */
(function () {
  if (window.__svHelpInit) return;
  window.__svHelpInit = true;

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function bind(root) {
    if (root.__svhBound) return;
    var form = root.querySelector('[data-svh-search]');
    var wrap = root.querySelector('[data-svh-faqs]');
    if (!form || !wrap) return;
    root.__svhBound = true;
    form.hidden = false;

    var input = form.querySelector('[data-svh-q]');
    var count = form.querySelector('[data-svh-count]');
    var empty = wrap.querySelector('[data-svh-empty]');
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-svh-q-item]'));
    var groups = Array.prototype.slice.call(wrap.querySelectorAll('[data-svh-group]'));
    var haystack = items.map(function (el) { return norm(el.textContent); });
    var wasOpen = items.map(function (el) { return el.open; });

    form.addEventListener('submit', function (e) { e.preventDefault(); });

    function run() {
      var q = norm(input.value).trim();
      var terms = q ? q.split(/\s+/) : [];
      var shown = 0;
      items.forEach(function (el, i) {
        var ok = terms.every(function (t) { return haystack[i].indexOf(t) > -1; });
        el.hidden = !ok;
        if (ok) shown++;
        if (terms.length) el.open = ok;
        else el.open = wasOpen[i];
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-svh-q-item]:not([hidden])');
      });
      if (empty) empty.hidden = !(terms.length && shown === 0);
      if (count) {
        count.textContent = !terms.length ? '' : shown === 0 ? 'Nenhum resultado.' : shown === 1 ? '1 resultado.' : shown + ' resultados.';
      }
    }

    input.addEventListener('input', run);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-svh]'), bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
